
import {Component, Vue, Prop, Watch} from "vue-property-decorator";
import {namespace} from "vuex-class";
import SummarySection from "@/components/utils/SummarySection.vue";
import preferencesService from "@/services/preferences.service";
import dataService from "@/services/data.service";
import frontService from "@/services/front.service";

const userModule = namespace("userModule");

@Component({
    components: {
        SummarySection
    },
})
export default class SidebarEnrichissement extends Vue {
    dialogSavePreferences = false;
    dialogResetPreferences = false;

    @Prop() readonly result!: { nb: number; credits: number };
    @Prop() readonly fileToUpload;
    @Prop() readonly preferenceFile;
    @Prop() readonly selectedData;
    @Prop() readonly selectedExportFormat;
    @Prop() readonly isCalculating: boolean;
    @Prop() readonly dataTypes;

    @userModule.State
    public user!: any;

    interval = 0;
    displayCredits = 0;
    preferenceName: string = null;
    isCounting = false;
    displayRecap = [];

    @Watch("selectedData", {deep: true})
    changeSelectedDataRecap() {
        this.displayRecap = dataService.recapDisplay(this.dataTypes, this.selectedData);
    }

    @Watch("result", {deep: true})
    changeDisplayNumber() {
        clearInterval(this.interval);

        if (this.result.credits === this.displayCredits) {
            return;
        }
        this.isCounting = true;

        this.interval = window.setInterval(
            function () {
                if (this.displayCredits != this.result.credits) {
                    let change = (this.result.credits - this.displayCredits) / 10;

                    change = change >= 0 ? Math.ceil(change) : Math.floor(change);

                    this.displayCredits = this.displayCredits + change;
                }
                if (this.displayCredits === this.result.credits) {
                    this.isCounting = false;
                }
            }.bind(this),
            20
        );
    }

    openModal() {
        if (this.preferenceFile.length > 0) {
            this.preferenceName = this.preferenceFile[0].name;
        } else {
            this.preferenceName = '';
        }
        this.dialogSavePreferences = true
    }

    savePreferenceFilter() {
        preferencesService.savePreferenceFilter({
            datas: this.selectedData,
            name: this.preferenceName,
            uuid: this.preferenceFile.length > 0 ? this.preferenceFile[0].uuid : null,
            id: this.preferenceFile.length > 0 ? this.preferenceFile[0].id : null,
            date: this.preferenceFile.length > 0 ? this.preferenceFile[0].date : null
        }, this.user.id, 'enrichment').then(res => {
            this.$emit('save-preference', (this.preferenceFile !== null && this.preferenceFile.length !== 0));
        });
    }

    formatNumber(x) {
        return frontService.numberWithSpaces(x);
    }
}
